module.exports = __webpack_public_path__ + "./docs/img/icon-ref_folder.90ba2ef103a6dcfa838ec1f8709a9e68.svg";